import { $axios, apiList } from '@/api'

export default {
    actions: {
        getPagesByCourse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.page.getPagesByCourse.method,
                    params: {
                        wsfunction: apiList.page.getPagesByCourse.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        viewPageModule(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.page.viewPageModule.method,
                    params: {
                        wsfunction: apiList.page.viewPageModule.moodle_method,
                    },
                    data: {
                        pageid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        }
    }
}
